export const opportunitiesStyles = (theme: any) => ({
  bg: {
    transform: 'rotate(-140deg)',
    marginTop: '70%',
    marginLeft: '-20%',
    scale: '150%',
    opacity: '0.6',
  },
  bg2: {
    transform: 'rotate(130deg)',
    marginTop: '300%',
    marginLeft: '-20%',
    scale: '150%',
    opacity: '0.6',
  },
  body: {
    position: 'relative',
    top: '93px',
    width: '80%',
    marginBottom: '200px',
  },
  title: {
    fontWeight: 'bold',
    fontFamily: 'Chakra Petch, sans-serif',
    color: 'white',
    fontSize: 'clamp(32px, 8vw, 65px)',
    marginTop: '50px',
    marginBottom: '30px',
  },
  test: {
    fontFamily: 'Inter, sans-serif',
    color: 'white',
    fontSize: 'clamp(15px, 3vw, 20px)',
    lineHeight: '23px',
    textAlign: 'left'
  },
  subtitle: {
    fontWeight: 'bold',
    fontFamily: 'Inter, sans-serif',
    color: 'white',
    fontSize: 'clamp(35px, 3vw, 48px)',
  },
  greyBox: { width: '300px', height: '150px', backgroundColor: 'grey', margin: '1%' },
  sponsor: {
    maxHeight: '50%',
    margin: '0 10px',
  },
  link: { display: 'flex', justifyContent: 'center', margin: '20px' },
});
